import { fetchFromBookingAPI } from "@/api/baseAPI";
import { InternalProperty } from "../types";

export const fetchPropertyData = async (propertyId: number): Promise<InternalProperty> => {
  const response = await fetchFromBookingAPI(`properties/${propertyId}`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  return response.json();
};